import xlsx from "json-as-xlsx";
import moment from 'moment';
import { calcRendimientoBruto, calcRendimientoExportable, calcManchaPorcentaje, calcDefectosManchaPor, calcTotalDefectosRedondeado } from './calidad-calculos.js';

const numberOrEmpty = (val) => {
  const n = Number(val);
  return isNaN(n) ? '' : n;
};

const safe = (v) => (v === undefined || v === null ? '' : v);

const CalidadListExport = (data) => {
  const xlsData = [
    {
      sheet: 'Calidad',
      columns: [
        // INFORMACIÓN GENERAL DE LA MUESTRA
        // Usar id_muestra si se registró en el formulario, si no , usar folio que se genera automáticamente
        { label: 'FOLIO', value: (row) => safe(row?.info_muestra?.id_muestra ?? row?.info_muestra?.folio) },
        { label: 'FECHA', value: (row) => safe(row?.info_muestra?.fecha) },
        { label: 'NIVEL', value: (row) => safe(row?.info_muestra?.tipo_analisis) },
        { label: 'TIPO', value: (row) => safe(row?.info_muestra?.nombre_tipo_muestra) },
        { label: 'NOMBRE', value: (row) => safe(row?.info_muestra?.nombre) },
        { label: 'ID ENTREGA/ LOTE', value: (row) => safe(row?.info_muestra?.id_acopio ?? row?.info_muestra?.id_recoleccion_acopio) },
        { label: 'REGIÓN', value: (row) => safe(row?.info_muestra?.region) },
        { label: 'MUNICIPIO', value: (row) => safe(row?.info_muestra?.nombre_municipio) },
        { label: 'LOCALIDAD', value: (row) => safe(row?.info_muestra?.nombre_localidad) },

        // RESUMEN DE ANÁLISIS
        { label: 'PROCESO', value: (row) => safe(row?.info_muestra?.nombre_tipo_proceso) },
        {
          label: 'RENDIMIENTO BRUTO',
          value: (row) => calcRendimientoBruto(row?.analisis_fisico?.pergamino_peso_muestra_pergamino, row?.analisis_fisico?.pergamino_peso_muestra_oro),
          format: '0.00'
        },
        {
          label: 'RENDIMIENTO EXPORTABLE',
          value: (row) => numberOrEmpty(row?.info_muestra?.rendimiento_exportable_por),
          format: '0.00'
        },
        { label: 'PUNTAJE TAZA', value: (row) => numberOrEmpty(row?.info_muestra?.puntaje_taza) },
        { label: 'OBSERVACIONES', value: (row) => safe(row?.info_muestra?.observaciones) },

        // ANÁLISIS FÍSICO
        { label: 'PESO DE LA MUESTRA', value: (row) => numberOrEmpty(row?.analisis_fisico?.pergamino_peso_muestra_pergamino) },
        { label: 'PESO ORO', value: (row) => numberOrEmpty(row?.analisis_fisico?.pergamino_peso_muestra_oro) },
        {
          label: 'RENDIMIENTO BRUTO',
          value: (row) => calcRendimientoBruto(row?.analisis_fisico?.pergamino_peso_muestra_pergamino, row?.analisis_fisico?.pergamino_peso_muestra_oro),
          format: '0.00'
        },
        { label: 'HUMEDAD (%)', value: (row) => numberOrEmpty(row?.analisis_fisico?.pergamino_humedad), format: '0.00' },
        {
          label: 'MANCHA',
          value: (row) => calcManchaPorcentaje(row?.analisis_fisico?.pergamino_peso_muestra_pergamino, row?.analisis_fisico?.pergamino_peso_mancha),
          format: '0.00'
        },
        { label: 'DENSIDAD (g./l.)', value: (row) => numberOrEmpty(row?.analisis_fisico?.pergamino_densidad), format: '0.00' },
        { label: 'ACTIVIDAD EN AGUA', value: (row) => safe(row?.analisis_fisico?.pergamino_actividad_agua) },
        { label: 'AROMA / OLOR', value: (row) => safe(row?.analisis_fisico?.olor_muestra) },

        // ANÁLISIS ORO
        {
          label: 'RENDIMIENTO EXPORTABLE',
          value: (row) => numberOrEmpty(row?.info_muestra?.rendimiento_exportable_por),
          format: '0.00'
        },
        {
          label: 'CRIBA / ZARANDA',
          value: (row) => {
            const arr = Array.isArray(row?.analisis_oro?.zarandas) ? row.analisis_oro.zarandas : [];
            return arr.map((z) => safe(z?.nombre_zaranda)).filter(Boolean).join(', ');
          }
        },
        {
          label: 'DEFECTOS (%)',
          value: (row) => calcDefectosManchaPor(row?.analisis_oro?.pergamino_peso_muestra_oro_2, row?.analisis_oro?.total_defectos_gramos),
          format: '0.00'
        },
        {
          label: 'TOTAL DEFECTOS',
          value: (row) => {
            const prim = Array.isArray(row?.analisis_oro?.defectos_primarios) ? row.analisis_oro.defectos_primarios : [];
            const sec = Array.isArray(row?.analisis_oro?.defectos_secundarios) ? row.analisis_oro.defectos_secundarios : [];
            const total = calcTotalDefectosRedondeado(prim, sec);
            return total > 0 ? total : '';
          }
        },
        {
          label: 'DEFECTOS',
          value: (row) => {
            const prim = (Array.isArray(row?.analisis_oro?.defectos_primarios) ? row.analisis_oro.defectos_primarios : []).map((item) => safe(item?.nombre_mancha)).filter(Boolean).join(', ');
            const sec = (Array.isArray(row?.analisis_oro?.defectos_secundarios) ? row.analisis_oro.defectos_secundarios : []).map((item) => safe(item?.nombre_mancha)).filter(Boolean).join(', ');
            return [prim, sec].filter(Boolean).join(' / ');
          }
        },
        { label: 'CAFE LIMPIO (grs.)', value: (row) => numberOrEmpty(row?.info_muestra?.peso_cafe_limpio_grs), format: '0.00' },
        { label: 'DESCUENTO POR PROCESAMIENTO (%)', value: (row) => numberOrEmpty(row?.analisis_oro?.perdida_procesamiento_por ?? row?.info_muestra?.perdida_procesamiento_por), format: '0.00' },
        {
          label: 'RENDIMIENTO REAL',
          value: (row) => {
            const re = Number(row?.info_muestra?.rendimiento_exportable_por ?? 0);
            const dp = Number(row?.info_muestra?.perdida_procesamiento_por ?? 0);
            if (re > 0 && dp >= 0) {
              return Number((re - dp).toFixed(2));
            }
            return '';
          },
          format: '0.00'
        },

        // ANÁLISIS SENSORIALES
        { label: 'PERFIL EN TAZA', value: (row) => safe(row?.analisis_sensorial?.perfil_taza) },
        { label: 'AROMA / FRAGANCIA', value: (row) => safe(row?.analisis_sensorial?.fragancia_aroma_desc) },
        { label: 'PUNTAJE EN TAZA', value: (row) => numberOrEmpty(row?.analisis_sensorial?.puntaje_manual) },
      ],
      content: data,
    },
  ];

  const settings = {
    fileName: `Listado_Calidad_${moment().format('YYYYMMDD_HHmmss')}`,
  };
  xlsx(xlsData, settings);
};

export default CalidadListExport;
